module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "calibre9",
    attrs: {
      "id": "pgepubid00001"
    }
  }, [_vm._v("\n      Contents\n    ")]), _vm._v(" "), _c('table', {
    staticClass: "calibre11",
    attrs: {
      "summary": ""
    }
  }, [_c('tbody', {
    staticClass: "calibre12"
  }, [_c('tr', {
    staticClass: "calibre13"
  }, [_c('td', {
    staticClass: "calibre14"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0003"
    }
  }, [_vm._v(" CHAPTER I. ")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre14"
  }, [_vm._v("\n          A DOUBLE ENIGMA\n        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre13"
  }, [_c('td', {
    staticClass: "calibre14"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0004"
    }
  }, [_vm._v(" CHAPTER II. ")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre14"
  }, [_vm._v("\n          THE TENANT OF THE NEW HALL\n        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre13"
  }, [_c('td', {
    staticClass: "calibre14"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" CHAPTER III. ")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre14"
  }, [_vm._v("\n          A HOUSE OF WONDERS\n        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre13"
  }, [_c('td', {
    staticClass: "calibre14"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" CHAPTER IV. ")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre14"
  }, [_vm._v("\n          FROM CLIME TO CLIME\n        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre13"
  }, [_c('td', {
    staticClass: "calibre14"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" CHAPTER V. ")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre14"
  }, [_vm._v("\n          LAURA'S REQUEST\n        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre13"
  }, [_c('td', {
    staticClass: "calibre14"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" CHAPTER VI. ")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre14"
  }, [_vm._v("\n          A STRANGE VISITOR\n        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre13"
  }, [_c('td', {
    staticClass: "calibre14"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" CHAPTER VII. ")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre14"
  }, [_vm._v("\n          THE WORKINGS OF WEALTH\n        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre13"
  }, [_c('td', {
    staticClass: "calibre14"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" CHAPTER VIII. ")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre14"
  }, [_vm._v("\n          A BILLIONAIRE'S PLANS\n        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre13"
  }, [_c('td', {
    staticClass: "calibre14"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" CHAPTER IX. ")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre14"
  }, [_vm._v("\n          A NEW DEPARTURE\n        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre13"
  }, [_c('td', {
    staticClass: "calibre14"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" CHAPTER X. ")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre14"
  }, [_vm._v("\n          THE GREAT SECRET\n        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre13"
  }, [_c('td', {
    staticClass: "calibre14"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" CHAPTER XI. ")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre14"
  }, [_vm._v("\n          A CHEMICAL DEMONSTRATION\n        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre13"
  }, [_c('td', {
    staticClass: "calibre14"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" CHAPTER XII. ")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre14"
  }, [_vm._v("\n          A FAMILY JAR\n        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre13"
  }, [_c('td', {
    staticClass: "calibre14"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" CHAPTER XIII.    ")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre14"
  }, [_vm._v("\n          A MIDNIGHT VENTURE\n        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre13"
  }, [_c('td', {
    staticClass: "calibre14"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" CHAPTER XIV. ")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre14"
  }, [_vm._v("\n          THE SPREAD OF THE BLIGHT\n        ")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre13"
  }, [_c('td', {
    staticClass: "calibre14"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" CHAPTER XV. ")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre14"
  }, [_vm._v("\n          THE GREATER SECRET")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a637da12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0002.vue
// module id = 60
// module chunks = 0